import * as React from 'react'

import { Box, Link } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import Callout from 'modules/core/components/Callout'
import { useAsyncData } from 'modules/core/hooks/useAsyncData'
import buildUrl from 'modules/core/lib/buildUrl'
import i18n from 'modules/core/lib/i18n'

import { useBookkeeperView } from 'modules/bookkeepers/lib/bookkeeperViewContext'
import { useLegalEntityContractData } from 'modules/contracts/lib/legalEntityContractDataContext'
import canSeeIntegration from 'modules/marketplace/lib/canSeeIntegration'
import integrationCodes from 'modules/marketplace/lib/integrationCodes'
import oauthService, { LOGIN_PATH } from 'modules/payroll_integrations_a3innuva/lib/OauthService'

interface Props {
  companyId: number
}

const Authentication = ({ companyId }: Props) => {
  const [show, setShow] = React.useState<boolean>(false)
  const { spanishContractData } = useLegalEntityContractData()
  const isBookkeeperView = useBookkeeperView()
  const loginUrl = buildUrl(`${LOGIN_PATH}/?company_id=${companyId}`)

  const canSeeA3InnuvaIntegration = Boolean(
    canSeeIntegration(integrationCodes.a3innuva, spanishContractData.companyInstallations)
  )

  const { loading } = useAsyncData(async () => {
    if (!canSeeA3InnuvaIntegration) return

    const notAuthenticated = await oauthService.isNotAuthenticated(
      { companyId: companyId, useOtherUsersTokensAsFallback: true },
      isBookkeeperView
    )
    setShow(canSeeA3InnuvaIntegration && notAuthenticated)
  }, [])

  if (loading || !show) return <></>

  return (
    <Box gap="s8">
      <Callout
        type="warning"
        description={i18n.t('payroll_integrations.oauth.banner.message')}
        compact
        link={
          <Link.Href href={loginUrl}>{i18n.t('payroll_integrations.oauth.banner.link')}</Link.Href>
        }
      />
    </Box>
  )
}

export default observer(Authentication)
